import React from 'react';

import styles from './Feedback.module.scss';
import Icon from '../Icon/Icon';
import Label from '../../context/Label/Label';

function Feedback({ children, correct, incorrect, className }) {
  const _className = [styles.Feedback];
  correct && _className.push(styles['--correct']);
  incorrect && _className.push(styles['--incorrect']);
  className && _className.push(className);

  return (
    <div className={_className.join(' ')}>
      <div className={styles.Feedback__type}>
        <Icon
          icon={correct ? 'check-circle' : 'times-circle'}
          className={styles.Feedback__icon}
        />
        <span>
          {correct ? <Label>correct</Label> : <Label>incorrect</Label>}
        </span>
      </div>
      <div className={styles.Feedback__text}>{children}</div>
    </div>
  );
}

export default Feedback;
